import Bottom from "./bottom.jsx";
export default Bottom;
